export default function AppBar(theme) {
  return {
    MuiAppBar: {
      styleOverrides: {
        root: {
          backgroundColor: `${theme.palette.grey.gb} !important`,
          color: theme.palette.text.primary,
          boxShadow: "unset",
          position: "absolute",
          backgroundImage: "unset",
          height: "56px",
          justifyContent: "center",
          alignItems: "center",
          right: "unset !important",
          width: "100%",
        },
      },
    },
  };
}
